import { render, staticRenderFns } from "./new-business-ticket.vue?vue&type=template&id=46c31b55&scoped=true&"
import script from "./new-business-ticket.vue?vue&type=script&lang=js&"
export * from "./new-business-ticket.vue?vue&type=script&lang=js&"
import style0 from "./new-business-ticket.vue?vue&type=style&index=0&id=46c31b55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c31b55",
  null
  
)

export default component.exports